import React from "react";
import { useSearchParams } from "react-router-dom";

import CustomTabPanel from "components/Shared/CustomTabPanel";
import CustomTabs from "components/Shared/CustomTabs";
import RowsSkeleton from "components/Shared/Skeleton/RowsSkeleton";
import NoteTab from "../../Note/Notetab";

import { useGetNotesBySourceQuery } from "store/services/noteApi";

import { useSendOutDetailContext } from "contexts/SendOutDetailContext";
import { useGetDocumentsBySourceQuery } from "store/services/documentApi";

import DocumentsTab from "../../Document/DocumentTab";
import SendOutShipmentTab from "./SendOutShipmentTab";

const SendOutDetailTab = () => {
  const [searchParams] = useSearchParams();

  const activeTab = searchParams.get("tab") || "note";

  const { sendOutDetail } = useSendOutDetailContext();

  // Fetch notes to get the count for the badge
  const { data: notes } = useGetNotesBySourceQuery(
    {
      source: "SendOut",
      sourceRef: sendOutDetail?._id,
    },
    { skip: !sendOutDetail?._id }
  );

  // Fetch documents to get the count for the badge
  const { data: documents } = useGetDocumentsBySourceQuery(
    { source: "SendOut", sourceRef: sendOutDetail?._id },
    { skip: !sendOutDetail?._id }
  );

  const tabs = [
    {
      label: "Note",
      value: "note",
      badgeCount: notes?.length || 0,
    },

    { label: "Document", value: "document", badgeCount: documents?.totalItems },

    { label: "Shipments", value: "shipments", badgeCount: sendOutDetail?.shipmentId?.length }

  ];

  return (
    <>
      <CustomTabs tabs={tabs} activeTab={activeTab} />

      {sendOutDetail ? (
        <>
          <CustomTabPanel activeTab={activeTab} value="note">
            <NoteTab source="SendOut" sourceRef={sendOutDetail._id} />
          </CustomTabPanel>

          <CustomTabPanel activeTab={activeTab} value="document">
            <DocumentsTab source="SendOut" sourceRef={sendOutDetail._id} />
          </CustomTabPanel>

          <CustomTabPanel activeTab={activeTab} value="shipments">
            <SendOutShipmentTab />
          </CustomTabPanel>
        </>
      ) : (
        <RowsSkeleton />
      )}
    </>
  );
};

export default SendOutDetailTab;
